module.exports = __webpack_public_path__ + "static/img/Gacha02.5b57996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha02.png
// module id = oOEh
// module chunks = 1